import React from 'react';
import { Icons } from '@usepepper/sprout-kit-ui';
import { OrderEntryMobileHeaderPanelIconButton } from '@/experiences/sales-portal/domain/ordering/screens/order-entry/components/order-entry-mobile-header-panel-icon-button';
import { useConfidentialFieldToggle } from '@/experiences/sales-portal/domain/ordering/blocs/hooks/use-confidential-field-toggle';

const ICON_SIZE = 18;

export const OrderEntryMobileConfidentialToggle: React.FC = () => {
  const { accessibilityLabel, isVisible, onToggle } =
    useConfidentialFieldToggle();

  return (
    <OrderEntryMobileHeaderPanelIconButton
      accessibilityLabel={accessibilityLabel}
      onPress={onToggle}
    >
      {isVisible ? (
        <Icons.Eye color="$iconPrimary" size={ICON_SIZE} />
      ) : (
        <Icons.EyeOff color="$iconSecondary" size={ICON_SIZE} />
      )}
    </OrderEntryMobileHeaderPanelIconButton>
  );
};
